import tokens from "config/constants/tokens"

const CRO_ADDRESS = tokens.cro.address

export { CRO_ADDRESS }